import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { feesMasterKeys } from '../feesMasterQueryKeys'
import { getFeesMaster } from '../feesMasterEndpoints'
import type { GetFeesMasterParams } from '../feesMasterContracts'

export function useFeesMasterQuery(
  params: MaybeRefOrGetter<GetFeesMasterParams> = {},
  isEnabled: MaybeRefOrGetter<boolean> = true,
) {
  return useQuery({
    queryKey: computed(() => feesMasterKeys.list(toValue(params))),
    queryFn: () => getFeesMaster(toValue(params)),
    enabled: () => Boolean(toValue(isEnabled)),
  })
}
